import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import loans from "../assets/images/loans.png";
import overdraftImg from "../assets/images/Overdraft.png";
import cash from "../assets/images/cash.png";
import bank from "../assets/images/bank.png";
import hand from "../assets/images/hand.png";
import emiImg from "../assets/images/emi.png";
import ship from "../assets/images/ship.png";
import growth from "../assets/images/growth.png";
import room from "../assets/images/room.png";
import certi from "../assets/images/certi.png";
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};



// Icons for funding categories
const ShipIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M8 30H32L28 24H12L8 30Z" fill="#4a5568"/>
    <path d="M12 24V16H28V24" stroke="#4a5568" strokeWidth="2" fill="none"/>
    <rect x="16" y="18" width="3" height="3" fill="#4a5568"/>
    <rect x="21" y="18" width="3" height="3" fill="#4a5568"/>
  </svg>
);



const FlameIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M20 6C20 6 28 14 28 22C28 28 24 32 20 32C16 32 12 28 12 22C12 14 20 6 20 6Z" fill="#ed8936"/>
    <path d="M20 14C20 14 24 18 24 24C24 28 22 32 20 32C18 32 16 28 16 24C16 18 20 14 20 14Z" fill="#f6ad55"/>
  </svg>
);

const CraneIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect x="6" y="32" width="28" height="3" fill="#4a5568"/>
    <rect x="18" y="14" width="4" height="18" fill="#4a5568"/>
    <path d="M20 14L30 10V14L20 18V14Z" fill="#4a5568"/>
    <rect x="26" y="14" width="2" height="10" fill="#4a5568"/>
    <rect x="24" y="22" width="6" height="6" fill="#718096"/>
  </svg>
);

const HandshakeIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M8 18L14 14L20 18L26 14L32 18V26L26 30L20 26L14 30L8 26V18Z" fill="#4a5568" fillOpacity="0.2"/>
    <path d="M12 20L18 24L26 20" stroke="#4a5568" strokeWidth="2" fill="none"/>
  </svg>
);

const ChartIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect x="8" y="8" width="24" height="20" rx="2" fill="#4a5568" fillOpacity="0.1" stroke="#4a5568" strokeWidth="2"/>
    <path d="M12 22L16 16L22 20L28 12" stroke="#4a5568" strokeWidth="2" fill="none"/>
    <rect x="6" y="30" width="28" height="4" rx="1" fill="#4a5568" fillOpacity="0.3"/>
  </svg>
);

const GrowthIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect x="8" y="24" width="6" height="10" rx="1" fill="#48bb78"/>
    <rect x="17" y="18" width="6" height="16" rx="1" fill="#38a169"/>
    <rect x="26" y="12" width="6" height="22" rx="1" fill="#276749"/>
    <path d="M20 12L30 6L32 10L36 4L30 6L31 9L22 14L20 12Z" fill="#48bb78"/>
  </svg>
);

const fundingCategories = [
  {
    title: 'Bank Loans & Credit Lines',
    subtitle: 'Traditional Financing Power.',
    items: [
      { name: 'Overdraft & Working Capital', image: overdraftImg },
      { name: 'Cash Credit', image:cash },
    ],
  },
  {
    title: 'Institutional Funding',
    subtitle: 'Alternative Capital Access.',
    items: [
      { name: 'NBFC & Co-Op Banks', image: bank },
      { name: 'Special Funding Institutions', image: hand },
    ],
  },
  {
    title: 'Capital Markets Opportunities',
    subtitle: 'Strategic Growth Pathways.',
    items: [
      { name: 'NCD Investments', image:certi },
      { name: 'IPO & Merchant Banking', image:growth },
    ],
  },
];

const fundingServices = [
  { title: 'Working Capital Loans', subtitle: 'Boost your cash flow.' },
  { title: 'Project Financing', subtitle: 'Fund your next big venture.' },
  { title: 'NBFC Solutions', subtitle: 'Customized lending options.' },
  { title: 'IPO Advisory', subtitle: 'Guide your path to listing.' },
];

const LoansPage = () => {
  const [activeTab, setActiveTab] = useState('coverage');

  const [loanAmount, setLoanAmount] = useState(500000);
const [interestRate, setInterestRate] = useState(10);
const [tenure, setTenure] = useState(5);
const [emi, setEmi] = useState(0);

useEffect(() => {
  const P = loanAmount;
  const R = interestRate / 12 / 100;
  const N = tenure * 12;

  if (P && R && N) {
    const emiCalc =
      (P * R * Math.pow(1 + R, N)) /
      (Math.pow(1 + R, N) - 1);

    setEmi(Math.round(emiCalc));
  }
}, [loanAmount, interestRate, tenure]);

  return (
    <div data-testid="loans-page" className="bg-gradient-to-b from-blue-50/30 to-white" style={{marginTop:"-80px"}}>
      {/* Hero Section */}
      <section className="py-16 text-center relative">

        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        {/* Background cityscape */}
        <div 
          className="absolute inset-0"
          style={{
           height: "624px",
            backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,1) 10%, rgba(255,255,255,0) 60%), url(${loans})`,
            backgroundSize: 'cover',
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
        <div className="max-w-6xl mx-auto px-6 relative">
            <h1 
              data-testid="loans-hero-title"
              className="text-4xl md:text-5xl font-semibold text-gray-900 mb-4"
            >
              Funding Solutions <span className="font-normal">for</span> Corporate Success.
            </h1>
            <p className="text-gray-600 text-lg mb-8">
              Your gateway to growth, from bank loans to private funding.
            </p>
            
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              <a
                href="#options"
                data-testid="view-loan-options-btn"
                className="cta-primary"
              >
                Calculate Your EMI
              </a>
              {/* <Link
                to="/contact"
                data-testid="get-funding-advice-btn"
                className="cta-secondary"
              >
                Get Funding Advice
              </Link> */}
            </div>
          {/* </motion.div> */}
        </div>
        
</motion.section>
      </section>

      {/* Funding Categories */}
      <section id="options" className="py-12" style={{marginTop:"250px"}}>
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            {fundingCategories.map((category, index) => (
              <motion.div
                key={category.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`funding-category-${index + 1}`}
                className="service-card bg-white rounded-xl p-6 border border-gray-200 
shadow-[0_-15px_40px_rgba(0,0,0,0.25),0_15px_40px_rgba(0,0,0,0.1)] 
hover:shadow-[0_-20px_60px_rgba(0,0,0,0.4),0_20px_50px_rgba(0,0,0,0.2)] 
transition duration-300"
              >
                <h3 className="font-semibold text-gray-900 mb-1">
                  {category.title}
                </h3>
                <p className="text-gray-500 text-sm mb-6">
                  {category.subtitle}
                </p>
                <div className="w-25 h-[1px] bg-gray-200 mx-auto mt-6" style={{marginTop:'-10px'}}></div> 
                <div className="grid grid-cols-2 mt-4">
                  {category.items.map((item, i) => {
                    return (
                      <div
                        key={item.name}
                        className={`text-center px-4 ${i === 0 ? "border-r border-gray-200" : ""}`}
                      >
                        <div className="flex justify-center mb-2">
                          {item.image ? (
                            <img
                              src={item.image}
                              alt={item.name}
                              className="w-30 h-30 object-contain drop-shadow-[0_8px_12px_rgba(0,0,0,0.9)]"
                            />
                          ) : (
                            item.icon && <item.icon />
                          )}
                        </div>
                        <p className="text-xs text-gray-600">{item.name}</p>
                      </div>
                    );
                  })}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        </motion.section>
      </section>

      {/* Feature Banners */}
{/* EMI Calculator */}
<section className="py-16 bg-gradient-to-b from-white to-green-50">
  <motion.section
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <div className="max-w-5xl mx-auto px-6">

      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
          EMI Calculator
        </h2>
        <p className="text-gray-600 mt-2">
          Plan your finances smartly with accurate EMI calculations.
        </p>
      </div>

      {/* Calculator Card */}
      <div className="bg-white rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-8 grid md:grid-cols-2 gap-8">

        {/* Inputs */}
        <div className="space-y-6">
          
          {/* Loan Amount */}
          <div>
            <label className="text-sm text-gray-600">Loan Amount (₹)</label>
            <input
              type="number"
              value={loanAmount}
              onChange={(e) => setLoanAmount(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          {/* Interest Rate */}
          <div>
            <label className="text-sm text-gray-600">Interest Rate (%)</label>
            <input
              type="number"
              value={interestRate}
              onChange={(e) => setInterestRate(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          {/* Tenure */}
          <div>
            <label className="text-sm text-gray-600">Loan Tenure (Years)</label>
            <input
              type="number"
              value={tenure}
              onChange={(e) => setTenure(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>
        </div>

        {/* Result */}
        <div className="flex flex-col justify-center items-center bg-green-50 rounded-xl p-6">
          <p className="text-gray-600 mb-2">Monthly EMI</p>
          <h3 className="text-3xl font-bold text-green-700">
            ₹ {emi}
          </h3>

          <div className="mt-6 text-sm text-gray-600 text-center">
            Based on your inputs, this is your estimated monthly payment.
          </div>
        </div>

      </div>
    </div>
  </motion.section>
</section>

      {/* Testimonial */}
      <section className="py-12">
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="quote-text text-xl mb-4">
            "Securing funds was smooth and seamless, opening new doors for our business."
          </p>
          <p className="text-gray-500">— Retail Chain Owner</p>
        </div>
        </motion.section>
      </section>

      {/* CTA Buttons */}
<section className="py-12">

  <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  <div className="max-w-6xl mx-auto px-6">
    <div className="flex flex-wrap justify-center gap-6">

      <Link
        to="/enquiry"
         className="bg-green-700 hover:bg-green-800 text-white px-12 py-4 rounded-full shadow-xl transition"
      >
        Get Funding Advice
      </Link>

      {/* <button
        className="px-8 py-3 bg-white text-gray-700 font-medium rounded-xl border border-gray-200 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
      >
        Download Funding Guide
      </button> */}

    </div>
  </div>
  </motion.section>
</section>
    </div>
  );
};

export default LoansPage;
